import { useConfig } from 'config/use-config';
import { COOKIE_NAMES } from 'constants/cookies';
import { CookieSerializeOptions } from 'cookie';
import { useEffect } from 'react';
import { useCookieStore } from 'stores/cookie';

export const CookieName = {
  Audiences: 'pd_audiences',
  Experiments: 'pd_ninetailed',
  CampaignSegment: COOKIE_NAMES.campaignSegment,
} as const;

export type CookieName = (typeof CookieName)[keyof typeof CookieName];

interface Input {
  cookieId?: CookieName;
  cookieValue?: string;
}

const useSetToCookie = ({ cookieId, cookieValue }: Input): void => {
  const { updateCookie } = useCookieStore();
  const { cookieDomain } = useConfig();

  useEffect(() => {
    // An unsettled source reads as undefined; only an empty string means "clear".
    if (cookieValue === undefined) {
      return;
    }

    const cookieName = cookieId || CookieName.Experiments;
    const options: CookieSerializeOptions = {
      path: '/',
      domain: cookieDomain,
    };

    if (cookieValue) {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      options.expires = date;
      updateCookie(cookieName, cookieValue, options);
    } else {
      // delete cookie value by setting expires
      const date = new Date();
      date.setTime(0);
      options.expires = date;
      updateCookie(cookieName, '', options);
    }
  }, [cookieDomain, cookieId, cookieValue, updateCookie]);
};

export default useSetToCookie;
